module.exports = __webpack_public_path__ + "static/media/source.58a49508.svg";